// DiwaliGiftPopup.jsx
import React from "react";
import Mresult from '../Assets/Dewali_campaign/M_result.png'
import { Box } from "@mui/material";
import bg_design_top_reverse from '../Assets/Dewali_campaign/bg_design_top_reverse.png'
import Lamp from '../Assets/Dewali_campaign/Lamp.png'
import voucher from '../Assets/Dewali_campaign/voucher_icon.png'
import { useLocation } from "react-router-dom";
const PurchaseDetails = () => {
  const location = useLocation()
  const selectedGiftCard = location?.state?.selectedBrand
  console.log(location.state,selectedGiftCard)
  const email = sessionStorage.getItem('email')
  return (
    <div className="mt-20 w-[90%] overflow-y-auto max-h-[85vh] max-w-md mx-auto p-6 bg-white rounded-2xl shadow-lg text-center relative overflow-hidden" style={{scrollbarWidth: "none", OverflowStyle: "none", }}>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100px",
          background:
            `url(${bg_design_top_reverse}) no-repeat center bottom / contain`,
          opacity: 0.3,
        }}
      />
      <h2 className="text-2xl mt-4 font-bold text-gray-800">Thank you for claiming your Diwali gift from MResult!
</h2>

  <div className="text-base text-[#8D5E3D] font-medium">Here’s your 
  <span className="text-[#F59200] font-semibold text-sm mb-6">₹2,000 {selectedGiftCard?.name} Gift Voucher</span>
  , along with steps to redeem it.
  </div>
      
       <img
          src={Lamp}
          alt="lamp"
          className="absolute top-[190px] left-[20%] -translate-x-1/2 w-[60px]"
        />
         <img
          src={Lamp}
          alt="lamp"
          className="absolute top-[200px] left-1/2 -translate-x-1/2 w-[60px] scale-125"
        />
        <img
          src={Lamp}
          alt="lamp"
          className="absolute top-[190px] right-[20%] translate-x-1/2 w-[60px]"
        />
      <div className="mb-4">
        <img src={Mresult} alt="MResult Logo" className="mx-auto h-10 absolute -top-10" />
      </div>

      

      <div className="bg-[#FFF3DE] rounded-xl p-4 mb-6 mt-24">
        <p className="text-[#7B4722] font-medium text-lg">
          Your <span className="font-bold text-xl">{selectedGiftCard?.name}</span> voucher worth
          <span className="font-bold text-xl"> ₹2,000 </span>
          has been successfully claimed.
        </p>
        <div className="mt-3 text-sm text-[#7B4722]">
          <img className="w-4 inline mr-2 mb-1" src={voucher}></img>Voucher code sent to:
          <p className="font-medium text-[#7B4722]">{email}</p>
        </div>
      </div>

      <div className="bg-[#F4F4F4] rounded-xl p-4 mb-6 text-left">
        <h3 className="font-medium text-lg text-[#424242] mb-2">What's Next</h3>
        <ol className="list-decimal  space-y-2 text-base text-[#424242] pl-2 ml-3">
          <li className="">Check your email for the voucher code and usage instructions</li>
          <li>
            Visit <span className="">{selectedGiftCard?.name}</span> and apply the voucher code at checkout
          </li>
          <li>Enjoy your Diwali shopping!</li>
        </ol>
      </div>

        <hr className="botder-2 border-gray-400 my-4"/>


      <div className="text-sm text-[#532708] mb-2">
        Need help? Contact HR or support@cheggout.com
      </div>

      <div className="text-[#532708] font-semibold flex flex-col items-center mb-10">
        Happy Diwali from Team MResult!
        <img
          src={Lamp}
          alt="lamp"
          className=" w-[60px]"
        />
      </div>
      
    </div>
  );
};

export default PurchaseDetails;
